/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @type {string} Profile Category action types.
 */

export const SET_LOADING = '[PROFILE_CATEGORY] SET_LOADING';
export const SET_PROFILE_CATEGORY_LIST = '[PROFILE_CATEGORY] SET_PROFILE_CATEGORY_LIST';

